module.exports = __webpack_public_path__ + "img/doc_filters.eced68ab.gif";